(function ($) {
  "use strict";

  $(document).ready(function () {
    $(".wp-block-board-tab-block").each(function () {
      const $block = $(this); // scope to this block instance

      const $header = $("header");

      const $tabsList = $block.find(".tab-block__wrapper-tabs__list");
      const $tabsWrapper = $block.find(".tab-block__wrapper-tabs");
      const $tabs = $block.find(".tab-block__wrapper-tabs__list-item");
      const $contents = $block.find(".tab-child-block__wrapper");
      const $tabsBody = $block.find(".tab-block__wrapper-tabs-body");
      const $tabsNavLeft = $block.find(".tab-block__wrapper-tabs-nav__left");
      const $tabsNavRight = $block.find(".tab-block__wrapper-tabs-nav__right");
      const $tabsMainSticky = $block.find(
        ".tab-block__wrapper-tabs-main.sticky",
      );

      function scrollTabContentToTop() {
        if ($tabsBody.length === 0 || $tabsMainSticky.length === 0) return;

        const tabsBodyRect = $tabsBody[0].getBoundingClientRect();
        const tabMainStickyRect = $tabsMainSticky[0].getBoundingClientRect();
        // Get gap from the wrapper that contains both tabs and body
        const $tabsWrapperContainer = $block.find(
          ".tab-block__wrapper-tabs-wrapper",
        );
        const contentGap =
          $tabsWrapperContainer.length > 0
            ? parseFloat(
                window.getComputedStyle($tabsWrapperContainer[0]).gap,
              ) || 0
            : 0;

        if (tabsBodyRect.top < tabMainStickyRect.bottom) {
          // Calculate scroll amount to position tabs body right after sticky tab bottom
          const scrollAmount =
            tabsBodyRect.top - (tabMainStickyRect.bottom + contentGap);
          // Scroll the window
          window.scrollTo({
            top: window.scrollY + scrollAmount,
            behavior: "smooth",
          });
        }
      }

      // Function to update sticky visibility
      function updateStickyVisibility() {
        if ($tabsMainSticky.length === 0) return;

        const headerRect = $header[0].getBoundingClientRect();
        const $activeContent = $contents.filter(".active");

        // If no active content, use first content as fallback
        const $contentToCheck =
          $activeContent.length > 0 ? $activeContent : $contents.eq(0);

        if ($contentToCheck.length === 0) return;

        const contentsRect = $contentToCheck[0].getBoundingClientRect();
        const tabMainStickyRect = $tabsMainSticky[0].getBoundingClientRect();

        if (
          tabMainStickyRect.top < headerRect.bottom &&
          contentsRect.bottom >= headerRect.bottom
        ) {
          $tabsMainSticky.addClass("sticky-visible");
          $tabsMainSticky.css("top", `${headerRect.bottom}px`);
        } else if (
          tabMainStickyRect.top > headerRect.bottom ||
          contentsRect.bottom < headerRect.bottom
        ) {
          $tabsMainSticky.removeClass("sticky-visible");
          $tabsMainSticky.css("top", "");
        }
      }

      // Run on load
      updateStickyVisibility();

      // Update on scroll and resize
      $(window).on("scroll resize", updateStickyVisibility);

      if ($tabs.length === 0 || $contents.length === 0) return;

      // ------------------------
      // Activate a tab
      // ------------------------
      function activateTab(i) {
        $tabs.removeClass("active");
        $contents.removeClass("active");

        $tabs.eq(i).addClass("active");
        $contents.eq(i).addClass("active");
      }

      // Default: activate first tab
      activateTab(0);

      // On click tab items
      $tabs.each(function (i) {
        $(this).on("click", function () {
          activateTab(i);
          scrollActiveTabIntoView();
          scrollTabContentToTop();
          setTimeout(function () {
            updateArrows();
            updateStickyVisibility();
          }, 250);
        });
      });

      function updateArrows() {
        const listEl = $tabsList[0];
        if (!listEl || !listEl.children.length) {
          $tabsNavLeft.css("display", "none");
          $tabsNavRight.css("display", "none");
          return;
        }

        // Use scroll metrics + edge tab geometry to handle sub-pixel rounding and smooth-scroll timing.
        const maxScrollLeft = listEl.scrollWidth - listEl.clientWidth;
        const scrollLeft = listEl.scrollLeft;
        const EPS = 1; // tolerance to handle sub-pixel/rounding
        const firstTabEl = listEl.children[0];
        const lastTabEl = listEl.children[listEl.children.length - 1];
        const listRect = listEl.getBoundingClientRect();
        const firstRect = firstTabEl
          ? firstTabEl.getBoundingClientRect()
          : null;
        const lastRect = lastTabEl ? lastTabEl.getBoundingClientRect() : null;
        const style = window.getComputedStyle(listEl);
        const padLeft = parseFloat(style.paddingLeft) || 0;
        const padRight = parseFloat(style.paddingRight) || 0;
        const firstFullyVisible =
          !!firstRect && firstRect.left >= listRect.left + padLeft - EPS;
        const lastFullyVisible =
          !!lastRect && lastRect.right <= listRect.right - padRight + EPS;
        const $activeTab = $tabs.filter(".active");
        const activeIndex = $tabs.index($activeTab);
        const isFirstActive = activeIndex === 0;
        const isLastActive = activeIndex === listEl.children.length - 1;

        // Show left arrow if we can scroll left
        if (!isFirstActive && scrollLeft > EPS && !firstFullyVisible) {
          $tabsNavLeft.css("display", "flex");
        } else {
          $tabsNavLeft.css("display", "none");
        }

        // Show right arrow if we can scroll right
        if (
          !isLastActive &&
          maxScrollLeft > EPS &&
          scrollLeft < maxScrollLeft - EPS &&
          !lastFullyVisible
        ) {
          $tabsNavRight.css("display", "flex");
        } else {
          $tabsNavRight.css("display", "none");
        }
      }

      // Run on load
      updateArrows();

      // Update on scroll
      $tabsList.on("scroll", updateArrows);
      // Run on window resize
      $(window).on("resize scroll", function () {
        updateArrows();
      });

      // ------------------------
      // Scroll active tab into view
      // ------------------------
      function scrollActiveTabIntoView(direction = null) {
        const listEl = $tabsList[0];
        const $active = $tabs.filter(".active");
        if (!$active.length || !listEl) return;

        const activeEl = $active[0];
        const index = $tabs.index($active);

        // Keep arrow state in sync with both immediate and smooth scrolling updates.
        function syncArrowsAfterScroll() {
          updateArrows();
          requestAnimationFrame(updateArrows);
          setTimeout(updateArrows, 240);
        }

        // Check screen width for mobile behavior
        const screenWidth =
          window.innerWidth || document.documentElement.clientWidth;
        const isMobile = screenWidth <= 575;

        // For mobile screens (<= 575px), center the active tab
        if (isMobile) {
          const listRect = listEl.getBoundingClientRect();
          const elRect = activeEl.getBoundingClientRect();
          const maxScrollLeft = listEl.scrollWidth - listEl.clientWidth;

          // Calculate center position
          const listCenter = listRect.left + listRect.width / 2;
          const elCenter = elRect.left + elRect.width / 2;
          const delta = elCenter - listCenter;
          const target = listEl.scrollLeft + delta;

          listEl.scrollTo({
            left: Math.max(0, Math.min(maxScrollLeft, target)),
            behavior: "smooth",
          });
          syncArrowsAfterScroll();
          return;
        }

        // Original behavior for larger screens
        // dynamic padding
        const cs = window.getComputedStyle(listEl);
        const padLeft = parseFloat(cs.paddingLeft) || 0;
        const padRight = parseFloat(cs.paddingRight) || 0;

        // arrow visibility
        const leftArrowVisible = $tabsNavLeft.css("display") !== "none";
        const rightArrowVisible = $tabsNavRight.css("display") !== "none";

        const anyArrowHidden = !leftArrowVisible || !rightArrowVisible;
        const leftArrowWidth = anyArrowHidden
          ? $tabsNavLeft.outerWidth(true)
          : 0;
        const rightArrowWidth = anyArrowHidden
          ? $tabsNavRight.outerWidth(true)
          : 0;
        const gap = anyArrowHidden
          ? parseFloat($tabsWrapper.css("gap")) || 0
          : 0;

        // list rect
        const listRect = listEl.getBoundingClientRect();
        const elRect = activeEl.getBoundingClientRect();
        const maxScrollLeft = listEl.scrollWidth - listEl.clientWidth;
        const wrapperRect = $tabsWrapper[0].getBoundingClientRect();

        // Find tabs not fully visible
        let hiddenTabsCount = 0;
        $tabs.each(function () {
          const tabRect = this.getBoundingClientRect();

          // Check if tab is outside wrapper on the right or left
          if (
            tabRect.right > wrapperRect.right ||
            tabRect.left < wrapperRect.left
          ) {
            hiddenTabsCount++;
          }
        });

        // Deterministic edge snapping prevents needing a second click for long edge titles.
        if (index === 0) {
          listEl.scrollTo({ left: 0, behavior: "smooth" });
          syncArrowsAfterScroll();
          return;
        }
        if (index === $tabs.length - 1) {
          listEl.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
          syncArrowsAfterScroll();
          return;
        }

        // LEFT navigation
        if (
          (direction === "left" || direction === null) &&
          elRect.left < listRect.left + padLeft
        ) {
          // If the tab is outside view
          if (elRect.left < listRect.left + padLeft) {
            // **Do not add leftArrowWidth + gap for the first tab**
            const innerLeft = listRect.left + padLeft;
            const delta = elRect.left - innerLeft;
            const target = listEl.scrollLeft + delta;
            listEl.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
            syncArrowsAfterScroll();
          }
          return;
        }

        // RIGHT navigation
        if (
          (direction === "right" || direction === null) &&
          elRect.right > listRect.right - padRight
        ) {
          if (elRect.right > listRect.right - padRight) {
            if (index === $tabs.length - 1) {
              // Always allow the last tab to reach the far edge when its title is very long.
              listEl.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
            } else {
              const innerRight =
                listRect.right - padRight - rightArrowWidth - gap;
              const delta = elRect.right - innerRight;
              const target = listEl.scrollLeft + delta;
              listEl.scrollTo({
                left: Math.min(maxScrollLeft, target),
                behavior: "smooth",
              });
            }
            syncArrowsAfterScroll();
          }
          return;
        }
      }

      // ------------------------
      // Left navigation
      // ------------------------
      $tabsNavLeft.on("click", function () {
        const $current = $tabs.filter(".active");
        const $prevTab = $current.prev();
        if ($prevTab.length > 0) {
          activateTab($prevTab.index());

          // Ensure arrow visibility updated synchronously
          updateArrows();

          requestAnimationFrame(() => {
            scrollActiveTabIntoView("left");
            setTimeout(function () {
              updateArrows();
              updateStickyVisibility();
            }, 250);
          });
        }
      });

      // ------------------------
      // Right navigation
      // ------------------------
      $tabsNavRight.on("click", function () {
        const $current = $tabs.filter(".active");
        const $nextTab = $current.next();
        if ($nextTab.length > 0) {
          activateTab($nextTab.index());

          updateArrows();

          requestAnimationFrame(() => {
            scrollActiveTabIntoView("right");
            setTimeout(function () {
              updateArrows();
              updateStickyVisibility();
            }, 250);
          });
        }
      });
    }); // .each()
  });
})(jQuery);
